export const SVG_ICON_PATHS = {
  editIcon:
    'M12.052,2.495l2.7,2.7a.293.293,0,0,1,0,.413L8.214,12.146l-2.778.308a.582.582,0,0,1-.644-.644L5.1,9.032l6.538-6.538A.293.293,0,0,1,12.052,2.495ZM16.9,1.809,15.44.348a1.171,1.171,0,0,0-1.652,0l-1.06,1.06a.293.293,0,0,0,0,.413l2.7,2.7a.293.293,0,0,0,.413,0l1.06-1.06a1.171,1.171,0,0,0,0-1.652Zm-5.406,8.558v3.047H1.916V3.836H8.795a.368.368,0,0,0,.254-.1l1.2-1.2a.359.359,0,0,0-.254-.614H1.437A1.437,1.437,0,0,0,0,3.357V13.894a1.437,1.437,0,0,0,1.437,1.437H11.974a1.437,1.437,0,0,0,1.437-1.437V9.17a.36.36,0,0,0-.614-.254l-1.2,1.2A.368.368,0,0,0,11.495,10.367Z',
  filterIcon:
    'M17.094 0H.842a.845.845 0 00-.595 1.44l6.478 6.5v7.244a.845.845 0 00.359.691l2.8 1.968a.841.841 0 001.323-.691V7.943l6.479-6.5A.845.845 0 0017.094 0z',
  circleCrossIcon:
    'M9.353 7.998L6.184 4.829 9.353 1.66A.961.961 0 007.994.301L4.825 3.47 1.656.301A.961.961 0 00.297 1.66l3.169 3.169L.297 7.998a.929.929 0 000 1.359.955.955 0 001.359 0l3.169-3.169 3.169 3.169a.965.965 0 001.359 0 .955.955 0 000-1.359z',
  uploadIcon:
    'M10.67 6.5V0H1.14A1.14 1.14 0 000 1.15v22.19a1.14 1.14 0 001.14 1.15h16.02a1.14 1.14 0 001.14-1.15V7.65h-6.48a1.15 1.15 0 01-1.15-1.15zm3.11 10.33h-3.1v3.83a.76.76 0 01-.77.76H8.4a.76.76 0 01-.77-.76v-3.82h-3.1a.77.77 0 01-.54-1.31l4.6-4.58a.81.81 0 011.14 0l4.6 4.58a.77.77 0 01-.54 1.3zm4.19-11.8L13.3.32a1.14 1.14 0 00-.81-.33h-.29v6.12h6.1v-.29a1.15 1.15 0 00-.34-.8z',
  downloadIcon:
    'M10.67 6.5V0H1.14A1.14 1.14 0 000 1.15v22.19a1.14 1.14 0 001.14 1.15h16.02a1.14 1.14 0 001.14-1.15V7.65h-6.48a1.15 1.15 0 01-1.15-1.15zm3.11 6.5a.77.77 0 01.54 1.31l-4.6 4.58a.81.81 0 01-1.14 0l-4.6-4.58a.77.77 0 01.54-1.3h3.1v-3.83a.76.76 0 01.77-.76h2.51a.76.76 0 01.77.76v3.82h3.1zM17.97 5.03L13.3.32a1.14 1.14 0 00-.81-.33h-.29v6.12h6.1v-.29a1.15 1.15 0 00-.34-.8z',
  calendarIcon:
    'M.64 10.3H23.4a.65.65 0 01.64.64V24.9a2.58 2.58 0 01-2.57 2.58H2.57A2.58 2.58 0 010 24.9V10.95a.65.65 0 01.64-.65zm23.4-2.36V6a2.58 2.58 0 00-2.57-2.58h-2.58V.64a.65.65 0 00-.65-.64H16.1a.65.65 0 00-.64.64v2.8H8.58V.63A.65.65 0 007.95 0H5.8a.65.65 0 00-.64.64v2.8H2.58A2.58 2.58 0 000 6v1.93a.65.65 0 00.64.64H23.4a.65.65 0 00.64-.64z',
  toolsIcon:
    'M24.15 3.8a6.13 6.13 0 01-8.69 7.68l-1.7 1.86 1.21 1.21.73-.72a.94.94 0 011.33 0l5.87 5.92a.94.94 0 010 1.34l-2.68 2.67a.94.94 0 01-1.34 0l-5.86-5.92a.94.94 0 010-1.34l.66-.66-1.15-1.15-8.1 8.86a1.9 1.9 0 01-2.68 0l-.67-.67a1.9 1.9 0 010-2.68l9.23-7.74-6.13-6.14H2.24L0 2.7 1.8.9l3.7 2.26.02 1.9 6.2 6.23 1.8-1.52A6.14 6.14 0 0120.8.46l-3.98 3.92 3.35 3.34 3.98-3.93zM3.3 21.13a.95.95 0 100 1.34.95.95 0 000-1.34z',
  graphIcon:
    'M31.64 0L18 13.5 13.5 9 0 22.64l4.5 4.5 9-9.14 4.5 4.5 18-18zM0 31.5V36h36v-4.5z',
  tvPlayIcon:
    'M30 6H18.61l4.94-4.93L22.5 0l-6 6-6-6-1.06 1.07L14.39 6H3a3 3 0 00-3 3v18a3 3 0 003 3h27a3 3 0 003-3V9a3 3 0 00-3-3zm0 21H3V9h27zM12 12v12l10.5-6z',
  bellIcon:
    'M13.6 24.4a.91.91 0 00-.9.72 1.76 1.76 0 01-.35.77 1.33 1.33 0 01-1.13.41 1.35 1.35 0 01-1.13-.41 1.76 1.76 0 01-.36-.77.91.91 0 00-.89-.71.92.92 0 00-.9 1.11 3.14 3.14 0 003.28 2.61 3.14 3.14 0 003.27-2.6.92.92 0 00-.9-1.12zM22.2 20.83c-1.09-1.42-3.22-2.26-3.22-8.65 0-6.56-2.9-9.2-5.6-9.83-.25-.06-.44-.15-.44-.42v-.2A1.73 1.73 0 0011.26 0h-.04a1.73 1.73 0 00-1.7 1.73v.2c0 .26-.17.36-.43.42-2.7.64-5.6 3.27-5.6 9.83 0 6.39-2.13 7.22-3.21 8.65a1.4 1.4 0 001.12 2.24h19.7a1.4 1.4 0 001.1-2.24zm-2.75.41H3.05a.3.3 0 01-.23-.51 8.52 8.52 0 001.48-2.35 15.93 15.93 0 001-6.2 10.78 10.78 0 011.47-6.1A4.51 4.51 0 019.5 4.13a2.46 2.46 0 001.31-.73.56.56 0 01.84-.02 2.55 2.55 0 001.32.75 4.51 4.51 0 012.72 1.95 10.78 10.78 0 011.47 6.1 15.93 15.93 0 001 6.2 8.62 8.62 0 001.52 2.38.3.3 0 01-.22.48z',
};

export const API_RESOURCE_URLS = {
  VC_QUANTITY: 'production-planning/vc/quantity',
  LAST_ASN_GENERATED_DATE: 'production-planning/vc/last-asn-generated-date',
  lastAgSNGeneratedDate: (plantId, lineId) =>
    `production-planning/plants/${plantId}/lines/${lineId}/last-agsn-generated-date`,
  lastFreezableDate: (plantId, lineId, date) =>
    `production-planning/plants/${plantId}/lines/${lineId}/last-freezable-date?plan-date=${date}`,
  materialsForGivenPlantAndLine: (plantId, lineId) =>
    `production-planning/plants/${plantId}/lines/${lineId}/materials`,
  generateAggregateSequence: (plantId, lineId) =>
    `production-planning/plants/${plantId}/lines/${lineId}/generate-aggregate-sequence`,
  addEmergencyAgsn: (plantId, lineId) =>
    `production-planning/plants/${plantId}/lines/${lineId}/add-emergency-aggregate-plan-for-other-destinations`,
  uploadOtherPlantAggregatePlanQuantities: (plantId, lineId) =>
    `production-planning/plants/${plantId}/lines/${lineId}/update-aggregate-plan-for-other-destinations`,
  aggregateSequence: (date, plantId, lineId) =>
    `production-planning/plants/${plantId}/lines/${lineId}/aggregate-sequence?date=${date}`,
  aggregateSequenceFreePool: (date, plantId, lineId) =>
    `production-planning/plants/${plantId}/lines/${lineId}/matched-free-pool-materials?productionDate=${date}`,
  updateAggregateSequence: (plantId, lineId) =>
    `production-planning/plants/${plantId}/lines/${lineId}/update-aggregate-sequence`,
  emergencyProducedChildMaterial: (plantId, shopType) =>
    `production-planning/plants/${plantId}/shop-types/${shopType}/planned-emergency-produced-materials`,
  interplantAggregateAssignmentView: (plantId, shopType) =>
    `production-planning/plants/${plantId}/shop-types/${shopType}/other-plant-f40-aggregates-conflicts`,
  emergencyAgsnAssignDate: (plantId, lineId) =>
    `production-planning/plants/${plantId}/lines/${lineId}/generate-emergency-agsn`,
  InterPlantAssignDate: (plantId, lineId) =>
    `production-planning/plants/${plantId}/line/${lineId}/f40-date-conflict-resolution`,
  emergencyAgsnEarliestAsnAppendableAdate: (plantId, lineId) =>
    `production-planning/plants/${plantId}/lines/${lineId}/earliest-asn-appendable-date`,
  linedOutAggregates: (plantId, lineId) =>
    `production-planning/plants/${plantId}/lines/${lineId}/lined-out-aggregates`,
  agsnReadyForDrop: (plantId, lineId) =>
    `/production-planning/plants/${plantId}/lines/${lineId}/agsn-ready-for-drop`,
  AGSN_LINE_OUT: (lineId) =>
    `production-planning/line/${lineId}/agsn-line-out`,
  AGSN_LINE_OUT_REJECT: (lineId) =>
    `production-planning/line/${lineId}/reject-asn-line-out`,
  FIRST_EMERGENCY_ASN_DATE:
    'production-planning/vc/first-possible-emergency-asn-date',
  VC_SEQUENCE: 'production-planning/vc/sequence',
  VC_ASN: 'production-planning/vc/asn',
  VC_ASN_LINE_OUT: (lineId) =>
    `production-planning/line/${lineId}/asn-line-out`,
  VC_ASN_LINE_OUT_UPDATED: (lineId) =>
    `production-planning/line/${lineId}/approve-agsn-line-out`,
  vcAsnReadyForDrop: (plantId, lineId) =>
    `production-planning/plants/${plantId}/lines/${lineId}/asn-ready-for-drop`,
  VC_LINEON: 'production-planning/asn-line-on',
  AGSN_LINEON: 'production-planning/agsn-line-on',
  VC_ASN_BULK: 'production-planning/asn-archive',
  carryForward: (plantId, lineId) =>
    `production-planning/plants/${plantId}/lines/${lineId}/asn-carry-forward`,
  INFORMATION_RADIATOR: 'information-radiator',
  LAST_HISTORIC_ASN_GENERATED_NOTIFICATIONS: 'push-notification/snapshot',
  LIVE_NOTIFICATIONS: 'push-notification/stream',
  VC_DESCRIPTION: 'production-planning/master-data/vc-description',
  VC_EMERGENCY_CHASSIS_REQUEST: 'production-planning/vc/create-emergency-chassis-request',
  COUNTRIES: 'production-planning/master-data/countries',
  FBV_VENDORS: 'production-planning/master-data/fbv-vendors',
  POWER_STEERING_VENDORS:
    'production-planning/master-data/power-steering-vendors',
  LINE_OUT_STATISTICS: 'planning-statistics/line-out',
  VC_QUANTITY_SEQUENCE_ASN: 'production-planning/vc/quantity-sequence-asn',
  emergencybulkupload: (plantId, lineId, shopId) =>
    `production-planning/plant/${plantId}/line/${lineId}/shop/${shopId}/vc/bulk-quantity-sequence-asn`,
  ASN_TRANSITION_STATISTICS: 'planning-statistics/asn-transition',
  EMERGENCY_ASN_STATISTICS: 'planning-statistics/emergency-asn',
  ARCHIVED_ASN_STATISTICS: 'planning-statistics/archived-asn',
  PLANTS: 'production-planning/plants',
  AUTH_BULK_RESOURCE: 'authorization/bulk-allowed-resources',
  PLAN_REVISION_STATISTICS: 'planning-statistics/plan-change',
  USER_PROFILE: 'production-planning/user-profile',
  VC_COST_RELEASE: 'material-master/cost-release',
  LOG_ERROR: 'logs/v2',
  COLOURS: 'production-planning/master-data/colours',
  evrUpdate: (plantId) => `production-planning/plantId/${plantId}/update-evr-quantity`,
  agsn: (plantId, lineId) =>
    `production-planning/plants/${plantId}/lines/${lineId}/aggregate-sequence`,
  vcs: plant => `/production-planning/master-data/plant/${plant}/vc`,
  shiftAssignments: (plantId, shopId, lineId, fromDate, toDate) =>
    `production-planning/plants/${plantId}/shops/${shopId}/lines/${lineId}/shift-assignments?fromDate=${fromDate}&toDate=${toDate}`,
  assignShiftToMaterial: (plantId, lineId) =>
    `production-planning/plants/${plantId}/lines/${lineId}/assign-shift-to-asn`,
  assignShiftToMaterialWhileSequencing: (plantId, lineId) =>
    `production-planning/plants/${plantId}/lines/${lineId}/assign-shift-to-sequence`,
  assignNextMonthVin: (plantId, lineId) =>
    `production-planning/plants/${plantId}/lines/${lineId}/assign-next-month-vin`,
  addTyreAndOtherRemark: (plantId, lineId) =>
    `production-planning/plants/${plantId}/lines/${lineId}/add-tyre-and-other`,
  lineDetailsByLineId: lineId => `plant-master/lines/${lineId}`,
  aggregateParts: (plantId, lineId) =>
    `/production-planning/chassis-line-parts/${plantId}/${lineId}`,
  generateAgSN: (plantId, lineId) =>
    `/production-planning/plants/${plantId}/lines/${lineId}/generate-agsn`,
  asnMaterialGroupClusters: (plantId, lineId, materialClusterName) =>
    `/production-planning/plant/${plantId}/line/${lineId}/materialGroupClusters/${materialNameToURLSafeStringMap[materialClusterName]}/updateAggregateDispatchStatuses`,
  aggregatePlan: (plant, line, fromDate, toDate) =>
    `/production-planning/plants/${plant}/lines/${line}/material-quantity-summary?fromDate=${fromDate}&toDate=${toDate}`,
  SEQUENCE_ADHERENCE_STATISTICS: `planning-statistics/sequence-adherence`,
  getAggregatePlanConflicts: (plantId, shopType, date) =>
    `production-planning/plants/${plantId}/shop-types/${shopType}/produced-child-materials?parentMaterialPlannedProductionDate=${date}`,
  getOtherAggregatePlanConflicts: (plantId, line) =>
    `production-planning/plant/${plantId}/line/${line}/other-plant-aggregate-conflicts`,
  resolveAggregatePlanConflicts: (plant, date) =>
    `production-planning/plants/${plant}/associate-child-materials-to-line?date=${date}`,
  resolviewAggregatePlanConflicts: (plant, line) =>
    `production-planning/plant/${plant}/line/${line}/resolve-other-plant-aggregate-conflicts`,
  resolveEmergencyAgsnConflicts: plant =>
    `production-planning/plants/${plant}/assign-lines-to-materials `,
  resolveInterPlantAggregateConflicts: plant =>
    `production-planning/plants/${plant}/f40-line-conflict-resolution `,
  getPantnagarBiwProducedChildMaterials: (plantId, shopType, date) =>
    `production-planning/plants/${plantId}/shop-types/${shopType}/pantnagar-biw-produced-child-materials?parentMaterialPlannedProductionDate=${date}`,
  getSwappableAggregates: (plant, line, materialId, destination) =>
    `production-planning/plants/${plant}/lines/${line}/materials/${materialId}/destination/${destination}/swappable-aggregates`,
  aggregateDispatch: (plantId, lineId) =>
    `production-planning/plants/${plantId}/lines/${lineId}/dispatch-aggregates`,
  aggregateSwap: (plant, line, materialId) =>
    `production-planning/plants/${plant}/lines/${line}/materials/${materialId}/swap-aggregate`,
  agsnPullback: (plant, line) =>
    `production-planning/plants/${plant}/lines/${line}/agsn-pullback`,
  asnPullback: (plant, line) =>
    `production-planning/plants/${plant}/lines/${line}/asn-pullback`,
  lines: plant => `production-planning/plants/${plant}/lines`,
  agsnCarryForward: (plant, line) =>
    `production-planning/plants/${plant}/lines/${line}/agsn-carry-forward`,
  getLinedOutChassis: (plantId, lineId) =>
    `production-planning/plants/${plantId}/lines/${lineId}/lined-out-chassis`,
  getMasterShiftPerPlant: plantId =>
    `production-planning/plants/${plantId}/master-shifts`,
  addMasterShift: plantId =>
    `production-planning/plants/${plantId}/master-shifts`,
  getDroppingUpdate: (plantId, lineId, status, limit) =>
    `/production-planning/plants/${plantId}/lines/${lineId}/material-dropping-updates?status=${status}&limit=${limit}`,
  droppingUpdate: (plantId) => `production-planning/dropping-update/${plantId}`,
  getAllDroppingUpdate: (plantId) => `production-planning/get-all-dropping-update/${plantId}`,
  updateStatusPrintDispatch: (plantId) => `production-planning/update-status-print-dispatch/${plantId}`,
  getStatusPrintDispatch: (plantId, asnIds) => `production-planning/get-status-print-dispatch/${plantId}?asnIds=${asnIds}`,
  chassisAsnOverView: (plantId, lineId, date) =>
    `production-planning/plants/${plantId}/lines/${lineId}/chassis-asn-overview?productionDate=${date}`,
  retroChassisAsnOverView: (plantId, lineId, date) =>
    `production-planning/plants/${plantId}/lines/${lineId}/retro-chassis-asn-overview?productionDate=${date}`,
  chassisAsnCountSummary: (plantId, lineId, date) =>
    `production-planning/plants/${plantId}/lines/${lineId}/chassis-asn-count-summary?productionDate=${date}`,
  chassisCriticalPartsPending: (plantId, lineId ,date) =>
    `production-planning/plants/${plantId}/lines/${lineId}/pending-critical-part-allotment?date=${date}`,
  additionalChassisInfo: (plantId, lineId) =>
    `production-planning/plants/${plantId}/lines/${lineId}/additional-chassis-info`,
  childMaterialStatus: (plantId, lineId) =>
    `production-planning/plants/${plantId}/lines/${lineId}/child-material-status`,
  getAlternatePart: plantId =>
    `production-planning/plant/${plantId}/alternate-materials`,
  getAsnOverviewReport: (plantId, lineId, toDate, fromDate) =>
    `production-planning/plants/${plantId}/lines/${lineId}/asn-overview-report?to=${toDate}&from=${fromDate}`,
  getoutsourceparts: (plantId, lineId) =>
    `production-planning/vc/asn/plant/${plantId}/line/${lineId}/outsource-parts`,
  getAgsnOverview: (plantId, lineId, date) =>
    `production-planning/plant/${plantId}/line/${lineId}/line-overview?productionDate=${date}`,
  aggregateMaterialstatus: (plantId, lineId, asnId) =>
    `production-planning/plants/${plantId}/lines/${lineId}/aggregate-material-status?asnId=${asnId}`,
  getEvrNumberOptions: (plantId) =>
    `production-planning/plant/${plantId}/evr-number`,
  getLineoutApprovalData: (lineId) =>
    `production-planning/chassis-line/${lineId}/agsn-line-out-approval`,
  getEmergencyASNData: (plantId, lineId) =>
    `production-planning/plant/${plantId}/line/${lineId}/get-emergency-asn-request`,
  emrgencyASNApprove: 'production-planning/vc/quantity-sequence-asn-approval',
  getAllEvrData: (plantId, fromDate, toDate) =>
    `production-planning/plantId/${plantId}/get-all-evr-data?fromDate=${fromDate}&toDate=${toDate}`,
  evrUpload: (plantId) => `production-planning/plantId/${plantId}/evr`,
  addEvrNumber: (plantId) => `production-planning/plantId/${plantId}/add-single-evr`,
  evrNumberCarryForward: (plantId) => `production-planning/plantId/${plantId}/carry-forward-evr`,
  getLinesForTransfer: (plantId, lineId,) =>
    `production-planning/plants/${plantId}/lines/${lineId}/get-lines-for-transfer`,
  getTransferableAsns: (plantId, lineId, toLine, date) =>
    `production-planning/plants/${plantId}/lines/${lineId}/get-transferable-asn?to-line=${toLine}&production-date=${date}`,
  updateSequenceAfterLineTransfer: (plantId, lineId) =>
    `production-planning/plants/${plantId}/lines/${lineId}/update-seq-transferred-asn`,
  getTransferableAgsns: (plantId, lineId, toLine, date) =>
    `production-planning/plants/${plantId}/lines/${lineId}/get-transferable-agsn?to-Line=${toLine}&production-date=${date}`,
  VC_MONTHLY_PROJECTION: 'production-planning/vc/monthly-projection',
  getPbsDroppingData: (plantId) => `production-planning/vc/asn/plant/${plantId}`,
  updatePbsStatus: (plantId) => `production-planning/pbs-out-status-update/${plantId}`,
  getUpdatedPbsDroppingData: (plantId) => `production-planning/get-all-pbs-out/${plantId}`,
  getEmergencyAgSNCount: (plant) =>
    `production-planning/plants/${plant}/emergency-count-summary`,
  getLineFeaturePerPlant: plantId =>
  `production-planning/line-feature-master/plant/${plantId}`,
  toggleLineFeature: () =>
  'production-planning/line-feature-master',
  getLineLimitsPerPlant: (plantId) =>
    `production-planning/master-limits/plant/${plantId}/line-limits`,
  updateLineLimits: () =>
    "production-planning/master-limits/update-line-limits",
  getShiftLimitsPerPlant: (plantId) =>
    `production-planning/master-limits/plant/${plantId}/shift-limits`,
  updateShiftLimits: () =>
    "production-planning/master-limits/update-shift-limits",
  getRfdLimitsPerPlant: (plantId) =>
    `production-planning/master-limits/plant/${plantId}/rfd-limits`,
  updateRfdLimits: () =>
    "production-planning/master-limits/update-rfd-limits",
  deleteSubAssembly: () =>
    'production-planning/sub-assembly-master/delete',
  getSubAssemblyConfigurations: (plantId, lineId) =>
    `production-planning/${plantId}/${lineId}/sub-assembly-configurations`,
  addSubAssemblyConfiguration: (plantId, lineId) =>
    `production-planning/${plantId}/${lineId}/sub-assembly-configuration`,
  addSubAssemblyDrooping: (plantId, lineId) =>
    `production-planning/${plantId}/${lineId}/sub-assembly-drooping`,
  engineDressingSequence: (plant, line) =>
  `production-planning/plants/${plant}/lines/${line}/engine-dressing-sequence`,
  getFreePoolAggregate: (plant,shopType) =>
     `production-planning/plants/${plant}/shop-type/${shopType}/get-free-pool-aggregates`
};
export const SORT_STATE = {
  ASCENDING: 'ascending',
  DESCENDING: 'descending',
  UNSORTED: 'unsorted',
};

export const ASN_STATUS = {
  READY_FOR_DROP: 'READY_FOR_DROP',
  LINE_OUT: 'LINE_OUT',
  LINED_OUT: 'LINED_OUT',
  PLANNED: 'PLANNED',
  ASN_GENERATED: 'ASN_GENERATED',
  LINE_ON: 'LINE_ON',
  DROPPED: 'DROPPED',
  ROLLED_OUT: 'ROLLED',
  WTCL: 'WTCL',
  SFLT: 'SFLT',
};

export const VC_ASN_STATUS = {
  READY_FOR_DROP: 'READY_FOR_DROP',
  LINE_OUT: 'LINE_OUT',
  PLANNED: 'PLANNED',
  LINE_ON: 'LINE_ON',
  LINED_OUT: 'LINED_OUT',
  ASN_GENERATED: 'ASN_GENERATED',
  DROPPED: 'DROPPED',
  ROLLED_OUT: 'ROLLED',
  WTCL: 'WTCL',
  SFLT: 'SFLT',
};

export const AGGREGATE_STATUS = {
  DISPATCHED: 'DISPATCHED',
  NOT_AVAILABLE: 'NOT_AVAILABLE',
  PLANNED: 'PLANNED',
  LINE_OUT: 'LINE_OUT',
  LINED_OUT: 'LINED_OUT',
  READY_FOR_PICKUP: 'READY_FOR_PICKUP',
  LINE_ON: 'LINE_ON',
  BOOKED: 'BOOKED',
  ASN_GENERATED: 'ASN_GENERATED',
  READY_FOR_DROP: 'READY_FOR_DROP',
  DROPPED: 'DROPPED',
};

export const AGGREGATES = {
  FRAME: 'Frame',
  REAR_AXLE: 'Rear Axle',
  FRONT_AXLE: 'Front Axle',
  ENGINE: 'Engine',
  GEAR_BOX: 'Gear box',
  CYLINDER_HEAD: 'Cylinder Head',
  CAB: 'Cab',
  PAINT: 'Paint',
  BIW: 'BIW',
  MATERIAL: 'Material',
  CRITICALMATERIAL: 'Critical Material',
  CAMSHAFT: 'Camshaft',
  CYLINDER_BLOCK: 'Cylinder Block',
  CRANKSHAFT: 'Crankshaft',
};

export const AGGREGATESMASTER = {
  MASTERCAPACITYCONFIGURATOR: 'Master Capacity Configurator'
};

export const CHASSIS_COLUMN = {
  CHASSIS: 'Chassis',
};

export const AGGREGATESMATERIAL = {
  FRAME: 'Frame',
  REAR_AXLE: 'Rear Axle',
  FRONT_AXLE: 'Front Axle',
  ENGINE: 'Engine',
  GEAR_BOX: 'Gear box',
  CYLINDER_HEAD: 'Cylinder Head',
  CAB: 'Cab',
  PAINT: 'Paint',
  BIW: 'BIW',
  MATERIAL: 'Material',
};

export const materialNameToURLSafeStringMap = {
  Frame: 'Frame',
  'Rear Axle': 'Rear%20Axle',
  'Front Axle': 'Front%20Axle',
  Engine: 'Engine',
  'Gear Box': 'Gear%20box',
  Cab: 'Cab',
  Paint: 'Paint',
  BIW: 'BIW',
  Material: 'Material',
};

export const SCREEN_REFRESH_INTERVAL_TIME_MS = 60000;

export const PUNE_CV_PLANT = '1001';
export const PUNE_CV_PLANT_NAME = 'Pune';
export const D3_LINE = '1000';
export const H3_LINE = '1002';
export const D3_LINE_NAME = 'D3';
export const T3_LINE = '1025';
export const ULTRA_LINE = '1199';
export const T3_LINE_NAME = 'T3';
export const ULTRA_LINE_NAME = 'ULTRA';
export const JAMSHEDPUR_PLANT = '2001';
export const JAMSHEDPUR_PLANT_NAME = 'Jamshedpur';
export const TCL_LINE = '1031';
export const TCL_LINE_NAME = 'TCL';
export const PANTNAGAR_PLANT = '3100';
export const PANTNAGAR_PLANT_NAME = 'Pantnagar';

export const MESSAGE_TYPE = {
  SUCCESS: 'Success',
  FAILURE: 'Fail',
  INFORMATION: 'Information',
  INTERNAL_ERROR: 'Internal Error',
  LOADING: 'Loading',
  NETWORK_ERROR: 'Network Error',
};

export const PROCUREMENT_TYPE_SPCL = {
  E99: '99',
  E98: '98',
  F40: '40'
};

export const ENV_TYPES = {
  TEST: 'TEST',
};

export const DISPLAY_MESSAGES = {
  NAVIGATION_WARNING:
    'You have unsaved changes. If you leave this page, your edits will be lost. Do you still want to continue?',
  NO_ASN_FOUND: 'ASNs are yet to be generated.',
  DUPLICATE_VC_COMBO_WARNING: 'Failed! Duplicate VC entry found.Reason: A {VC} with the same color code and country code already exists for this month.How to proceed: Check existing entries while uploading plan',
  DUPLICATE_PART_COMBO_WARNING: 'Failed! Duplicate PART entry found.Reason: A Part with the same attributes already exists for this day.How to proceed: Check existing entries while uploading plan',
  VC_ADD_FAILURE: 'VC addition failed. Pls try again or contact support.',
  PART_ADD_FAILURE: 'PART addition failed. Pls try again or contact support.',
  ASN_ADD_FAILURE: 'ASN addition failed. Pls try again or contact support.',
  AGSN_ADD_FAILURE: 'Emergency AgSn addition failed. Pls try again or contact support.',
  AGSN_LAST_DATE_FAILURE: 'Failed to get last-possible-emergency-asn-date',
  ASN_ADD_SUCCESS:
    'Emergency ASNs have been successfully added to the VC lineup screen',
  ASN_ADD_SUCCESS_PART:
    'Emergency ASNs have been successfully added to the Part lineup screen',
  POSITIVE_NUMBER_VALIDATION_WARNING: 'Failed! Invalid quantity entered. Reason: Negative or zero values are not allowed in Day Target or Additional Quantity. How to proceed: Enter only positive numbers to continue while uplading NEW VC & Emergency ASN PLAN',
  EDIT_NON_NEGATIVE_NUMBER_VALIDATION_WARNING:
    'Failed! Invalid quantity entered. Reason: Negative values are not allowed in Day Target. How to proceed: Enter 0 or higher to continue while editing the existing paln',
  DROP_SEQUENCE_VIOLATION_WARNING:
    'Chassis drop could not be done. \n You violated the sequence.',
  PLAN_UPLOAD_SUCCESS: 'Plan has been successfully uploaded.',
  EMERGENCY_PLAN_UPLOAD_SUCCESS: 'Emergency plan has been successfully uploaded.',
  EMERGENCY_PLAN_UPLOAD_PLANT_LINE_MISSING: 'Failed! Line/Plant ID is missing. Reason: The emergency plan upload requires a valid Line or Plant ID. How to proceed: Please select or enter the correct Line/Plant ID before uploading the plan',
  EMERGENCY_PLAN_UPLOAD_DATE_MISSING: 'Failed! Plan date is missing. Reason: The production date was not entered during the emergency plan upload. How to proceed: Please enter the production date to proceed with the upload',
  EMERGENCY_PLAN_UPLOAD_SHOP_MISSING: 'Failed! Shop ID is missing. Reason: The emergency plan upload requires a valid Shop ID. How to proceed: Please select or enter the correct Shop ID before uploading the plan.',
  EMERGENCY_PLAN_UPLOAD_VC_MISSING: 'Failed! VC number is missing. Reason: A valid VC number was not provided for the emergency plan upload. How to proceed: Please enter the VC number to continue with the upload',
  EMERGENCY_PLAN_UPLOAD_PART_MISSING: 'Failed! Part number is missing. Reason: A valid Part number was not provided for the emergency plan upload. How to proceed: Please enter the Part number to continue with the upload',
  EMERGENCY_PLAN_UPLOAD_ADDITIONAL_QUANTITY_MISSING:
    'Failed! Additional quantity is missing. Reason: The additional quantity field was left empty. How to proceed: Please enter the required additional quantity to continue.',
  EMERGENCY_PLAN_UPLOAD_AGENCY_MISSING: 'Failed! Agency information is missing. Reason: The emergency plan upload requires agency details. How to proceed: Please select or enter the agency before uploading',
  EMERGENCY_PLAN_UPLOAD_DATE_FORMAT_INVALID:
    'Failed! Invalid date format. Reason: The date entered is not in the required format (yyyy-mm-dd). How to proceed: Please enter the date in the correct format, e.g., 2025-09-10.',
  EMERGENCY_PLAN_UPLOAD_DATE_FORMAT_CHANGE:
    'Failed! Invalid plan date. Reason: The plan date cannot be later than the last frozen sequence date. How to proceed: Please select a valid date within the allowed range',
  EMERGENCY_PLAN_UPLOAD_REASON_MISSING: 'Failed! Reason is missing. Reason: A valid reason for the emergency plan change was not provided. How to proceed: Please select or enter a reason before uploading',
  PLAN_UPLOAD_FORBIDDEN:
    'Failed! Unauthorized action. Reason: You are not authorized to upload or edit plans for other Plants. How to proceed: Please contact your supervisor or IT support for the required permissions',
  PLAN_UPLOAD_ERROR:
    'Plan upload failed. Please resolve the listed errors and retry or connect with IT Team to resolve',

  PLAN_UPLOAD_INFORMATION:
    'Plan could not be uploaded. Clear following errors and try again.',
  PLAN_UPLOAD_INTERNAL_ERROR:
    'Plan could not be uploaded. Clear following errors and try again.',
  CLEAR_ERRORS: 'Clear following errors and try again',
  DROP_SEQUENCE_UPDATE: 'Dropping Sequence updated.',
  ALL_EDITS_SAVED: ' Edits have been saved',
  VC_STATUS_UPDATED: 'VC status updated.',
  PART_STATUS_UPDATED: 'Part status updated',
  VC_STATUS_LINEOUT: 'Success! The selected VC has been lined out. You can now view the corresponding line-out ASN details on the Line Out screen.',
  REJET_LINOUT : 'Success! LINEOUT successfully Rejected',
  PART_STATUS_LINEOUT: 'The selected Part has been successfully lined out. You can now view the corresponding line-out ASN details on the Line Out screenSuccess! The selected Part has been lined out. You can now view the corresponding line-out ASN details on the Line Out screen.',
  AGSN_STATUS_LINEOUT: 'Success! The selected AgSN has been lined out. You can now view the corresponding line-out AgSN details on the Line Out screen.',
  AGSN_STATUS_UPDATED: 'AgSN status updated',
  AGGREGATE_DISPATCH_UPDATED: 'Success! The selected AgSNs have been dispatched successfully',
  AGGREGATE_DISPATCH_FAILED: 'Aggregate Dispatch failed.',
  AGSN_STATUS_SWAP: 'Success! The selected AgSN has been successfully swapped',
  AGSN_STATUS_PULLBACK_FAILED:
    'Failed! AgSN pullback could not be completed. Reason: The system did not allow the pullback due to constraints. How to proceed: Please try again, or check if the AgSN is eligible for pullback',
  AGSN_STATUS_PULLBACK_SUCCESS:
    'Success! The selected AgSN has been pulled back. You can find the pulled-back AgSN in the previous day’s plan on the Line Up screen.',
  ASN_STATUS_PULLBACK_SUCCESS:
    'Success! The selected ASN has been pulled back. You can find the pulled-back ASN in the previous day’s plan on the Line Up screen',
  ASN_STATUS_PULLBACK_FAILED:
    'Failed! ASN pullback could not be completed. Reason: The system did not allow the pullback due to constraints. How to proceed: Please try again, or check if the ASN is eligible for pullback.',
  VC_UPDATE_FAILED: 'VC update failed.',
  PART_UPDATE_FAILED: 'Part update failed.',
  ASN_FETCH_FAILURE: '(Remove ASN Fetch Failed)',
  PLAN_DATA_ERROR: 'Invalid quantity entered.',
  ASN_GENERATION_ERROR: 'ASN could not be generated.',
  AGGREGATE_STATUS_UPDATED: 'Aggregate status updated.',
  AGGREGATE_GENERATE_SEQUENCE: 'Failed! Aggregate sequence could not be generated. Reason: Parent materials are in conflict, or the parent sequence {line name} is not yet generated. How to proceed: Please resolve the by connecting with aggregate PPC oF PARENT LINE{LINE NAME}',
  AGGREGATE_GENERATE_SEQUENCE_DATE_LESS_THEN_FREEZABLE_DATE:
    'Sequence of one of the parent line is not generated as per lead time',
  AGGREGATE_SWAP_FAILED: 'Aggregate SWAP could not be Performed',
  GET_AGGREGATE_SWAPPABLE_AGSN_FAILED: 'Unable to Fetch Swappable AgSN',
  OTHER_PLANT_UPLOAD_PLAN_FAILED: 'Unable to upload Aggregate Plan',
  OTHER_PLANT_UPLOAD_PLAN_SUCCESS: 'Success! Aggregate plan uploaded successfully',
  EMERGENCY_AGSN_PLAN_SUCCESS: 'Emergency Agsn uploaded successfully',
  VC_COST_RELEASE_NOT_FOUND_FOR_SEQUENCE:
    'Info! Cost release has expired for some VCs. Reason: The cost release period is no longer valid. How to proceed: Please connect with IT team to sync Production Master Data. Once synced, you can continue with planning',
  SHIFT_ASSIGNMENT_SUCCESS: 'Success! Shift has been assigned successfully',
  NEXT_MONTH_VIN_SUCCESS: 'Success! Month has been assigned successfully',
  RESOLVE_CONFLICT_SUCCESS: 'Success! All conflicts have been resolved successfully',
  RESOLVE_CONFLICT_FAILED: 'Failed! Conflict resolution could not be completed. Reason: The system returned an error while processing. How to proceed: Please retry, and if the issue persists, contact IT team',
  GENERATE_AGSN: 'Success! AgSN generated successfully',
  GENERATE_InterPlantAggregateAssignment: 'Success! InterPlant Aggregate Assignment generated successfully',
  PLAN_UPDATED_SUCCESSFUL: 'Success! Plan has been updated successfully',
  ASN_LINEON_FAILED: 'Failed! ASN line-on could not be completed. Reason: The system returned an error during the process. How to proceed: Please check backend error details or retry after corrections',
  INVALID_QUANTITY: 'Failed! Invalid quantity entered. Reason: Quantity must be a three-digit number up to 499. How to proceed: Please re-enter the quantity in the valid range (e.g., 001–499)',
  INVALID_NUMBER: 'Please use non-negative numbers only.',
  INVALID_INPUT: 'Add valid Quantity',
  ADD_MASTER_SHIFT_ERR_CONTEXT: 'Please clear the following error',
  ADD_MASTER_SHIFT_ERR_Info: shiftName =>
    `There is already an existing shift ${shiftName} with the same validity. Please change the validity and try again.`,
  ADDED_MASTER_SHIFT: 'You have successfully created master shift',
  CARRY_FORWARD: 'Success! Plan has been carried forward to the next date',
  DUPLICATE_COLOUR_CODE: 'Colour code already exists',
  DUPLICATE_COUNTRY_CODE: 'Country code already exists',
  COLOUR_ADD_FAILURE:
    'Failed! Colour addition could not be completed. Reason: The system encountered an error while adding the colour. How to proceed: Please retry the addition, and if the issue persists, contact support.',
  COUNTRY_ADD_FAILURE:
    'Failed! Country addition could not be completed. Reason: The system encountered an error while adding the country. How to proceed: Please retry the addition, and if the issue persists, contact support.',
  COLOUR_ADD_SUCCESS: 'Success! Colour added successfully',
  COUNTRY_ADD_SUCCESS: 'Success! Country added successfully',
  EVR_NUMBER_UPLOAD_SUCCESS: 'Success! EVR number file uploaded successfully.',
  EVR_NMBER_UPLOAD_FAIL: 'Evr Number addition failed. Pls try again or contact support.',
  UPDATE_EVR_NUMBER: 'You have successfully updated Evr Number',
  UPDATE_EVR_NUMBER_ERR: 'Evr Number Updation failed. Pls try again or contact support.',
  ASN_LINE_TRANSFER: 'Success! ASNs/AgSNs have been transferred successfully to the selected line',
  LINE_TRANSFER_ERROR: 'Failed! Line transfer could not be completed. Reason: The system encountered an error during line transfer. How to proceed: Please retry the transfer, and if the issue persists, check backend error details or contact support.',
  EVR_ADD_FAILURE: 'Evr Number addition failed.',
  EVR_NUMBER_CARRY_FORWARD_SUCCESS: 'EVR Carry forwarded to the next Month.',
  MONTH_PROJECTION_UPLOAD_SUCCESS: 'Month Projection uploaded.',
  MONTH_PLAN_UPLOAD_ERROR:
    'Monthly Projection could not be uploaded. Clear following errors and try again.',
  UPDATE_MONTH_PLAN_ERR: 'Month Plan Updation failed. Pls try again or contact support.',
  UPDATE_MONTH_PLAN: 'You have successfully updated monthly Plan',
  emergencyASNApprove: 'Success! You have successfully updated Emergency ASN Status',
  FORBIDDEN_ACCESS: 'You do not have permission for this operation'
};

export const TIME_DURATION = {
  LAST_SEVEN_DAYS: 'Last 7 days',
  LAST_FOUR_WEEKS: 'Last 4 weeks ',
  LAST_SIX_MONTHS: 'Last 6 months',
};

export const DATE_FORMAT = {
  ISO: 'YYYY-MM-DD',
  DD_MM_YYYY: 'DD-MM-YYYY',
  YYYY_MM: 'YYYY-MM'
};

export const AGGREGATE_SUBCOLUMN = {
  PLAN: 'Plan',
  LINE_UP: 'LINE UP',
  DISPATCH: 'Dispatch',
  AVAILABILITY: 'Availability',
  EMERGENCY_AGSN: 'EMERGENCY AgSN',
  AGSN_OVERVIEW: 'AGSN OVERVIEW',
  INTERPLANT_AGGREGATE_ASSIGNMENT: 'INTERPLANT AGGREGATE ASSIGNMENT',
  APPROVAL: 'Approval',
  SUB_ASSEMBLY_VIEW: 'SUB-ASSEMBLY LINE UP',
  SUB_ASSEMBLY_OVERVIEW: 'SUB-ASSEMBLY OVERVIEW',
  FREE_POOL_AGGREGATES:"FREE POOL AGGREGATES"
};

export const ENGINE_SUBCOLUMN={
  ENGINE_DRESSING_SEQUENCE:'ENGINE DRESSING SEQUENCE'
}
export const CHASSIS_SUBCOLUMN = {
  PLAN: 'Plan',
  LINE_UP: 'Line Up',
  VIEW_ASN: 'View Asn',
  MONTH_PLAN: 'Month Plan',
  AGGREGATE_VIEW_CONFLICTS: 'Interplant Aggregate Conflicts',
  APPROVAL: 'Approval',
  // EMERGENCY_ASN_APPROVAL: 'Emergency ASN Approval',
  SUB_ASSEMBLY_VIEW: 'SUB-ASSEMBLY LINE UP',
  SUB_ASSEMBLY_OVERVIEW: 'SUB-ASSEMBLY OVERVIEW',
};

export const MASTER_SUBCOLUMN = {
  LINE_FEATURE: 'Line Feature Configurator',
  LINE_CAPACITY: 'Line Capacity Configurator',
  SHIFT_CAPACITY: 'Shift Capacity Configurator',
  READY_FOR_DROP: 'Ready For Drop Limit Configurator',
  SUB_ASSEMBLY: 'Sub-Assembly Configurator',
};
export const APPROVAL_SUBCOLUMN = {
  LINE_OUT_APPROVAL: 'Line Out Approval',
  EMERGENCY_ASN_APPROVAL: 'Emergency ASN Approval'
}; 

export const ALL_MONTHS_IN_A_YEAR = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const LINE_PURPOSE = {
  CHASSIS: 'Chassis',
  FRAME: 'Frame',
  FRONT_AXEL: 'Front Axel',
  REAR_AXEL: 'Rear Axel',
  ENGINE: 'Engine',
  CAB: 'Cab',
  GEAR_BOX: 'Gear box',
  PAINT: 'Paint',
  BIW: 'BIW',
  CAMSHAFT: 'Camshaft',
  CYLINDER_HEAD: 'Cylinder head',
  CYLINDER_BLOCK: 'Cylinder Block',
  CRANKSHAFT: 'Crankshaft'
};

export const USER_OPERATIONS = {
  GET_COUNTRIES: 'get-countries',
  GET_FBV_VENDORS: 'get-fbv-vendors',
  CREATE_CHASSIS_PLAN_QUANTITY: 'create-chassis-plan-quantity',
  UPDATE_CHASSIS_PLAN_QUANTITY: 'update-chassis-plan-quantity',
  GET_CHASSIS_PLAN_QUANTITY: 'get-chassis-plan-quantity',
  CREATE_CHASSIS_PLAN_SEQUENCE: 'create-chassis-plan-sequence',
  GET_CHASSIS_PLAN_SEQUENCE: 'get-chassis-plan-sequence',
  CREATE_CHASSIS_PLAN_ASN: 'create-chassis-plan-asn',
  UPDATE_CHASSIS_PLAN_ASN: 'update-chassis-plan-asn',
  GET_CHASSIS_PLAN_ASN: 'get-chassis-plan-asn',
  UPDATE_AGGREGATE_DISPATCH: 'update-aggregate-dispatch',
  GET_AGGREGATE_DISPATCH: 'get-aggregate-dispatch',
  DELETE_CHASSIS_PLAN_ASN: 'delete-chassis-plan-asn',
  GET_PRODUCTION_STATISTICS: 'get-production-statistics',
  GET_LINES: 'get-lines',
  GET_MATERIAL_QUANTITY: 'get-material-quantity',
  CREATE_AGGREGATE_PLAN_SEQUENCE: 'create-aggregate-plan-sequence',
  UPDATE_AGGREGATE_PLAN_SEQUENCE: 'update-aggregate-plan-sequence',
  GET_LAST_FREEZABLE_DATE: 'get-last-freezable-date',
  GET_LAST_AGSN_GENERATED_DATE: 'get-last-agsn-generated-date',
  GET_CHILD_MATERIALS: 'get-child-materials',
  ASSIGN_MATERIAL_TO_LINE: 'assign-material-to-line',
  GET_MATERIAL_SEQUENCE: 'get-material-sequence',
  GENERATE_AGSN: 'generate-agsn',
  ASSIGN_SHIFT_TO_MATERIAL: 'assign-shift-to-material',
  AGGREGATE_READY_FOR_DROP: 'aggregate-ready-for-drop',
  AGGREGATE_LINE_OUT: 'aggregate-line-out',
  AGGREGATE_PULLBACK: 'aggregate-pullback',
  ASN_PULLBACK: 'update-chassis-plan-asn',
  AGGREGATE_LINE_ON: 'aggregate-line-on',
  AGGREGATE_SWAP: 'swap-aggregate',
  AGGREGATE_DISPATCH: 'aggregate-dispatch',
  GET_PRODUCTION_REVIEW: 'get-production-review',
  GET_DROPPING_UPDATE: 'get-dropping-update',
  GET_MANUFACTURING_INSIGHTS: 'get-manufacturing-insights',
  GET_MASTER_SHIFT_CONFIGURATOR: 'get-master-shift-configurator',
  ADD_MASTER_SHIFT: 'add-master-shift',
  GET_ASN_OVERVIEW: 'get-asn-overview',
  GET_MASTER_DATA: 'get-master-data',
  GET_DISPLAYABLE_SHOP_TYPES: 'get-displayable-shop-types',
  GET_SCM_MATERIAL_TAB: 'get-scm-material-tab',
  AGGREGATE_CARRYFORWARD: 'aggregate-carry-forward',
  GET_ALL_EVR: 'get-all-evr-data',
  UPDATE_EVR_QUANTITY: 'update-evr-quantity',
  ADD_EVR_DATA: 'add-evr-data',
  UPDATE_LINE_FEATURE: 'update-line-feature',
  UPDATE_MASTER_LIMTS: 'update-master-limits',
  GET_AGGREGATE_FOR_UTK: 'central-ppc-aggregate',
  GET_SUB_ASSEMBLY_CONFIGURATION: 'get-all-evr-data',
};

export const RESOURCE_TYPE = {
  CHASSIS: 'chassis',
  AGGREGATE: 'aggregate',
  MATERIAL: 'material',
  PRODUCTION_STATISTICS: 'production-statistics',
  PLANT: 'plant',
  DISPLAYABLE_SHOP: 'displayable-shop',
  DISPLAYABLE_SCM_MATERIAL_TAB: 'displayable-scm-material-tab',
  MASTER_SHIFT: 'master-shift',
  EVR_QUANTITY: 'evr-quantity',
  MASTER_CAPACITY: 'master-capacity',
  SUB_ASSEMBLY_CONFIGURATION: 'sub-assembly-configuration',
};

export const LOG_LEVEL = {
  INFO: { name: 'INFO', value: 1 },
  WARN: { name: 'WARN', value: 2 },
  ERROR: { name: 'ERROR', value: 3 },
};

export const APPLICATION_NAME = 'Enterprise Platform';

export const REGEX = {
  COLOR_CODE: /\(([^)]+)\)/,
  COUNTRY_NAME: /^[A-Za-z\s\-]+$/,
  COUNTRY_CODE: /^[A-Za-z0-9]+$/,
  COLOUR_CODE: /^[A-Za-z]+$/,
  COLOUR_NAME: /^[A-Za-z\_]+$/,
};

export const MESSAGE = {
  PARAMETER_ADD_SUCCESSFUL: 'Parameter has been added successfully',
  PARAMETER_EDIT_SUCCESSFUL: 'Parameter has been updated successfully',
  INVALID_HEADERS: 'File contains invalid headers',
  PARAMETER_MAPPING_FAILURE: 'Parameter mapping failed',
  DUPLICATE_ROWS: 'File contains duplicate rows',
  EQUIPMENT_ADD_FAILURE: 'Equipment could not be added',
  EQUIPMENT_TYPE_ADD_FAILURE: 'Equipment type could not be added',
  EQUIPMENT_ADD_SUCCESSFUL: 'Equipment has been added successfully',
  TAG_MAPPING_FAILURE: 'Tag mapping failed',
  FGSN_TAG_UPLOAD_FAILURE: 'FGSN Tag upload failed',
  FILE_INVALID_PARAMETERS: 'File contains invalid parameters',
  FGSN_LOAD_FAILURE: 'Failed to load fgsn tag',
};

export const TOOLS = {
  PRODUCTION_REVIEW: 'Production Review',
  ASN_OVERVIEW: 'ASN Overview',
  DROPPING_UPDATE: 'Dropping Update',
  MASTER_DATA_MANAGEMENT: 'Master Data Management',
  MANUFACTURING_INSIGHTS: 'Manufacturing Insights',
  SHIFT_CONFIGURATOR: 'Shift Configurator',
  ASN_OVERVIEW_REPORT: 'ASN Overview Report',
  EVR_CONFIGURATOR: 'Evr Number Configurator',
  MASTER_CAPACITY_CONFIGURATOR: 'Master Capacity Configurator',
  ENGINE_CONFIRMATION_UPDATE: 'Engine Confirmation Update',
  PBS_DROPPING_CONFIRMATION: 'PBS Dropping Confirmation',
  SUB_ASSEMBLY_CONFIGURATOR: 'Sub-Assembly Configurator',
};

export const LINE_TYPE = {
  MAIN: 'Main',
};

export const AGSN_SELECTOR_HEADER_TEXT =
  'Note: Drag the AgSN and position it into a preferred slot for DROP.';

export const ASN_SELECTOR_HEADER_TEXT =
  'Note: Drag the ASN and position it into a preferred slot for DROP.';

export const ACTIONS = {
  ADD: 'ADD',
  UPDATE: 'UPDATE',
};

export const APPLICATION_VARIANTS = {
  IPMS4: 'ipms4',
  MES4: 'mes4',
  MES4_EV: 'mes4-ev',
};

export const AGGREGATE_STATUS_FROM_PIPELINE = {
  AGGREGATE_STATUS_DEV: 'true',
  AGGREGATE_STATUS_PROD: 'false',
};

export const cabLinesForAllPlants = [
  'T1',
  'T2',
  'T3',
  'T4',
  'XT',
  'FAT',
  'FES',
];

export const JLR_PLANT = 'Pune JLR';

export const HEX_COLORS = {
  DARK_GREEN: '#26662E',
  DARK_BLUE: '#0380af',
  GRAY: '#D8D8D8',
  BLUE: '#608FC9',
  LIGHT_GRAY: '#DCE9EA',
};
export const APP_TITLE = {
  IPMS4: 'IPMS 4.0',
  MES4: 'MES 4.0',
};

export const INTERVAL_TYPE = {
  DAY: 'day',
  MONTH: 'month',
};
export const headerForExcel = [
  'Plant',
  'Line',
  'Vc no',
  'Category',
  'Market',
  'Defence',
  'Country code',
  'FBV',
  'FBV Vendor code',
  'Power steering',
  'Build card number',
  'Colour code',
  'EvrNumber',
];

export const mes4HeaderForExcel = ['Plant', 'Line', 'Vc no'];

export const headerForAgsnExcel = ['Part No.', 'Destination'];

export const headerForCabAgsnExcel = ['Part No.', 'Destination', 'Colour code', 'Country code'];


export const headerForEvrExcel = ['Plant', 'Vc no', 'Evr Number', 'Quantity', 'Valid From (YYYY-MM-DD)', 'Valid To (YYYY-MM-DD)', 'Country Name', 'Colour code'];

export const sheet2Data = [
  ['AB'],
  ['AMG'],
  ['ARB'],
  ['ARS'],
  ['ARTG'],
  ['ASB'],
  ['AW'],
  ['AZB'],
  ['BDG'],
  ['BLR'],
  ['BM'],
  ['BRK'],
  ['BSG'],
  ['BW'],
  ['CDR'],
  ['CED'],
  ['CGR'],
  ['CHB'],
  ['CHG'],
  ['CSG'],
  ['CYG'],
  ['DFG'],
  ['DG'],
  ['DNB'],
  ['DW'],
  ['FB'],
  ['GB'],
  ['GLB'],
  ['GY'],
  ['HWR'],
  ['IC'],
  ['IG'],
  ['ITBP'],
  ['JB'],
  ['LGO'],
  ['LTG'],
  ['MBR'],
  ['MDG'],
  ['MES'],
  ['MG'],
  ['MIB'],
  ['MLB'],
  ['MNB'],
  ['MNG'],
  ['MNR'],
  ['MNW'],
  ['MSR'],
  ['NA'],
  ['NB'],
  ['NFR'],
  ['NOR'],
  ['NPB'],
  ['NSB'],
  ['OAG'],
  ['ODB'],
  ['OG'],
  ['OGM'],
  ['PBG'],
  ['PBR'],
  ['PC'],
  ['PCB'],
  ['PP'],
  ['PR'],
  ['PRW'],
  ['PTS'],
  ['PW'],
  ['PWIB'],
  ['QB'],
  ['RB'],
  ['RR'],
  ['RRG'],
  ['SBL'],
  ['SDR'],
  ['SFB'],
  ['SG'],
  ['SGTG'],
  ['SGY'],
  ['SKG'],
  ['SLG'],
  ['SLM'],
  ['SMB'],
  ['SMM'],
  ['SO'],
  ['SRO'],
  ['SS'],
  ['SSO'],
  ['TBG'],
  ['TGR'],
  ['TNS'],
  ['TSIB'],
  ['TTW'],
  ['UBTG'],
  ['URB'],
  ['WNG'],
  ['ZY'],
  ['MTB'],
];

export const ADD_COLOUR_OR_COUNTRY = {
  COUNTRY: 'Add Country',
  COLOUR: 'Add Colour',
};

export const ZPL_ASN_TEMPLATE = `
^XA
^LH0,0
^FT15,80^A0N,70,70^FH^FD{ASN}^FS
^FT15,130^A0N,30,30^FH^FD{VC}^FS
^FT15,180^A0N,30,30^FH^FD{COLOUR}^FS
^FO15,205
^A0N,25,25
^FB560,2,0,L,0
^FD{DESC}^FS
^FT470,175^A0N,80,80^FH^FD{LINE}^FS
^FT470,115
^BQN,2,4
^FDLA,{ASNID}^FS
^XZ
`;

export const ZPL_ASN_TEMPLATE_FOR_DROPPING = `
^XA^MNM^CF0,30^FO20,10^FDFrom: PWI^FS^FO250,10^FDTo: TCF{LineID}^FS^CF0,60^FO20,60^FDASN: -{ASN}^FS^BY3,2,50^FO20,130^BC,N,N,N^FD{MaterialNumber}^FS^CF0,20^FO20,200^FD{MaterialNumber} ({MaterialDescription})^FS^FO20,235^FD{EngineMaterialDescription}  {EngineMaterialNumber}^FS^XZ`;

export const ZPL_AGSN_BIW_TEMPLATE = `
^XA
^BY2,2,50

^FT25,64^BCN,,N,N,,A^FD{materialNumber}^FS
^FT25,150^BCN,,N,N,,A^FD{agsnNumber}^FS

^BY2,2,50

^FT30,90^A0N,25,30^FH\\^CI28^FD{materialNumber}^FS^CI27
^FT30,210^A0N,25,30^FH\\^CI28^FD{materialDescription}^FS^CI27

^FT490,180^A0N,25,30^FH\\
^FT30,175^A0N,25,30,^FH\\^CI28^FD{agsnNumber}^FS^CI27

^FT400,30^A0N,20,25,^FH\\^CI28^FD{date}^FS^CI27
^FT320,190^A0N,20,25^FH\\^CI28^FDAgSN-{agsnNumber}^FS^CI27
^FT400,190^A0N,20,25^FH\\^CI28^FD^FS^CI27

^PQ2,,,Y
^XZ
`;
